import React, { FC, useContext, useEffect, useState } from 'react';
import { publicationAPI } from "../Redux/services/PublicationService";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalVariablesContext } from "../Infrastructure/provider/GlobalVariablesProvider";

const PublicationsPage: FC = () => {
    const { id } = useParams();
    const { data } = publicationAPI.useFetchPublicationsByIdCategoryQuery(id);
    const { setHeaderTitle } = useContext(GlobalVariablesContext);
    const [viewType, setViewType] = useState<'grid' | 'list'>('grid');
    const [sortType, setSortType] = useState<'date' | 'title'>('date');
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');

    const navigate = useNavigate();

    useEffect(() => {
        if (data) setHeaderTitle(data.categoryTitle || '');
        return () => setHeaderTitle('');
    }, [data]);

    const navigateToPost = (id: number) => {
        navigate(`/post/${id}`);
    };

    const sortedPublications = data?.publications
        ?.slice()
        ?.sort((a: any, b: any) => {
            if (sortType === 'title') {
                return sortDirection === 'asc'
                    ? a.title.localeCompare(b.title)
                    : b.title.localeCompare(a.title);
            } else {
                return sortDirection === 'asc'
                    ? new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
                    : new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
            }
        });

    return (
        <div className="h-[75vh] overflow-y-auto px-4">
            {/* Панель сортировки */}
            <div className="flex flex-wrap gap-4 items-center mb-8 bg-white/60 p-3 rounded-xl shadow-sm border border-blue-100">
                <div className="flex flex-col text-sm text-blue-900">
                    <label className="mb-1">Вигляд</label>
                    <select
                        value={viewType}
                        onChange={(e) => setViewType(e.target.value as 'grid' | 'list')}
                        className="bg-white border border-blue-200 rounded-md px-3 py-1 text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                        <option value="grid">Таблиця</option>
                        <option value="list">Список</option>
                    </select>
                </div>

                <div className="flex flex-col text-sm text-blue-900">
                    <label className="mb-1">Сортування</label>
                    <div className="flex gap-2">
                        <select
                            value={sortType}
                            onChange={(e) => setSortType(e.target.value as 'date' | 'title')}
                            className="bg-white border border-blue-200 rounded-md px-3 py-1 text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            <option value="date">Дата</option>
                            <option value="title">Назва</option>
                        </select>
                        <button
                            onClick={() => setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')}
                            className="px-2 text-blue-700 hover:text-blue-500 transition"
                        >
                            {sortDirection === 'asc' ? '↑' : '↓'}
                        </button>
                    </div>
                </div>
            </div>

            {/* Контейнер публикаций */}
            <div
                className={
                    viewType === 'grid'
                        ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'
                        : 'flex flex-col gap-4'
                }
            >
                {sortedPublications &&
                    sortedPublications.map((item: any) => (
                        <div
                            key={item.id}
                            onClick={() => navigateToPost(item.id)}
                            className={`${
                                item.read_at == null
                                    ? 'bg-red-200 text-white'
                                    : 'bg-white text-blue-700'
                            } rounded-2xl shadow-md p-6 hover:shadow-lg transition cursor-pointer`}
                        >
                            {/* Заголовок с обрезкой длинных названий */}
                            <div
                                className="font-semibold text-xl italic truncate"
                                title={item.title}
                            >
                                {item.title}
                            </div>

                            {viewType === 'list' && (
                                <div className="text-sm mt-2 text-blue-500 italic">
                                    {new Date(item.created_at).toLocaleDateString('uk-UA')}
                                </div>
                            )}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default PublicationsPage;
